import { Icon } from '../../../subkit-ui';
import Link from 'next/link';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LandingPageFooter = function LandingPageFooter() {
  return /*#__PURE__*/_jsx("div", {
    className: "px-4 h-auto md:h-33 bg-yellow-300 py-12 md:py-0",
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex justify-between flex-col md:flex-row items-center w-full h-full md:max-w-3/5 mx-auto",
      children: [/*#__PURE__*/_jsx("img", {
        className: "mb-8 md:my-auto self-start mx-auto md:mx-0",
        src: "/images/img_logo.png",
        style: {
          height: '36px'
        },
        alt: "Subkit Logo"
      }), /*#__PURE__*/_jsx("div", {
        className: "flex-1 min-w-4"
      }), /*#__PURE__*/_jsxs("div", {
        className: "my-auto flex items-center",
        children: [/*#__PURE__*/_jsx(Link, {
          href: "https://twitter.com/wearesubkit",
          children: /*#__PURE__*/_jsx("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/_jsx(Icon, {
              name: "twitter",
              type: "brand",
              className: "text-2xl p-3 clickable"
            })
          })
        }), /*#__PURE__*/_jsx(Link, {
          href: "https://www.instagram.com/subkit_gosolo/",
          children: /*#__PURE__*/_jsx("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/_jsx(Icon, {
              name: "instagram",
              type: "brand",
              className: "text-2xl p-3 clickable"
            })
          })
        }), /*#__PURE__*/_jsx(Link, {
          href: "https://www.youtube.com/channel/UCzLPEzaz8oXEY_2k7spiQQA/featured",
          children: /*#__PURE__*/_jsx("a", {
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/_jsx(Icon, {
              name: "youtube",
              type: "brand",
              className: "text-2xl p-3 clickable"
            })
          })
        })]
      })]
    })
  });
};

export default LandingPageFooter;